import type { StaffRole } from '@ucp/web/lib';

/**
 * Attendance surface roles (PRO-3050, ADR-018 PRO-3050 amendment). Mirrors the server role →
 * capability map in `types/auth.ts`; the server stays authoritative (503 before 403, per-school
 * capability checks). `L6_PLATFORM_ADMIN` holds no attendance capability and is never listed.
 */
export const ATTENDANCE_TAKE_ROLES: StaffRole[] = ['ATTENDANCE_RECORDER', 'ATTENDANCE_ADMIN'];
export const ATTENDANCE_AMEND_ROLES: StaffRole[] = ['ATTENDANCE_ADMIN'];
export const ATTENDANCE_CODE_FULL_ROLES: StaffRole[] = ['ATTENDANCE_ADMIN'];
export const ATTENDANCE_MONITOR_ROLES: StaffRole[] = [
  'ATTENDANCE_ADMIN',
  'ATTENDANCE_OFFICER',
  'PRINCIPAL',
  'OPS_DIRECTOR',
];
export const ATTENDANCE_REPORT_ROLES: StaffRole[] = [
  'ATTENDANCE_ADMIN',
  'ATTENDANCE_OFFICER',
  'PRINCIPAL',
  'OPS_DIRECTOR',
];
export const ATTENDANCE_EXPORT_ROLES: StaffRole[] = ['ATTENDANCE_OFFICER'];
/** Configure (admin), thresholds (officer) or confirm a mode change (principal). */
export const ATTENDANCE_SETTINGS_ROLES: StaffRole[] = [
  'ATTENDANCE_ADMIN',
  'ATTENDANCE_OFFICER',
  'PRINCIPAL',
];

/** The module route guard: any role that confers an attendance capability. */
export const ATTENDANCE_ROUTE_ROLES: StaffRole[] = [
  ...new Set<StaffRole>([
    ...ATTENDANCE_TAKE_ROLES,
    ...ATTENDANCE_MONITOR_ROLES,
    ...ATTENDANCE_REPORT_ROLES,
    ...ATTENDANCE_SETTINGS_ROLES,
  ]),
];
